// Mock data for Logardt Group website

export const mockContactSubmit = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock Contact Form Submission:', formData);
      
      // Determine which email address based on inquiry type
      const emailRouting = {
        'general': 'logardtgroup@gmail.com',
        'business-process': 'logardtgroup@gmail.com',
        'language-services': 'logardtgroup@gmail.com',
        'voice-over': 'logardtgroup@gmail.com',
        'remote-work': 'logartrecruiting@outlook.com',
        'flowmingo': 'logartrecruiting@outlook.com'
      };
      
      const routedEmail = emailRouting[formData.inquiryType] || 'logardtgroup@gmail.com';
      
      // Store in localStorage for demo purposes
      const submissions = JSON.parse(localStorage.getItem('contactSubmissions') || '[]');
      const newSubmission = {
        ...formData,
        routedTo: routedEmail,
        id: Date.now(),
        timestamp: new Date().toISOString()
      };
      submissions.push(newSubmission);
      localStorage.setItem('contactSubmissions', JSON.stringify(submissions));
      
      console.log(`Form routed to: ${routedEmail}`);
      
      resolve({
        success: true,
        message: 'Thank you for your inquiry. We will get back to you shortly.'
      });
    }, 1000);
  });
};

export const companyInfo = {
  name: 'Logardt Group',
  tagline: 'Strategic Management Consulting for SMEs',
  emails: {
    general: 'logardtgroup@gmail.com',
    recruiting: 'logartrecruiting@outlook.com'
  },
  aboutUs: {
    title: 'About Us',
    description: 'We provide management consulting services for SMEs and start-ups globally. Our areas of expertise goes from starting a business and conducting business to developing business operations. If you are encountering any difficulties, want to digitalize a process or if you wish to make a process more efficient and cost-effective, please contact us for a quote. We work with cases regarding smaller assignments and with projects which may encompass several processes.'
  },
  services: {
    title: 'Our Services',
    consulting: {
      title: 'Management & Strategy Consulting',
      description: 'Comprehensive consulting services for SMEs covering business operations, digitalization, and process optimization.'
    },
    flowmingo: {
      title: 'Flowmingo AI Recruiter',
      subtitle: 'No.1 Free AI Interviewer',
      description: 'Flowmingo AI recruiter is a human-first, async interview experience — built for hiring teams tired of chasing calendars and wasting calls. It streamlines the interview process, making it more cost effective, and delivers an interview performance report to the recruiter right after the interview.',
      videoUrl: 'https://www.youtube.com/embed/3xrjWjxAsBQ',
      signupUrl: 'https://flowmingo.ai/?utm_source=22TDRAGC',
      advantages: [
        'Free forever — no demo walls, no pricing bait.',
        'Eliminates interviews — candidates answer asynchronously, and teams get structured insights.',
        'Real human support — replying means direct, personal help from you.'
      ]
    },
    recruiting: {
      title: 'Recruiting Partner',
      partners: ['SuperAnnotate', 'Flowmingo AI']
    }
  }
};
